import React from 'react';
import FormGroupWrapper from '../blocks/FormGroupWrapper';

type Props = {
  id: string;
  label: string;
  name: string;
  value: number | string;
  groupClass?: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  required?: boolean;
}

const Input = (props: Props): React.ReactElement => {
  const {
    id, label, onChange, value, name, required, groupClass,
  } = props;

  return (
    <FormGroupWrapper groupClasses={groupClass}>
      <label htmlFor={name} className="col-form-label">{label}</label>
      <textarea
        className="form-control"
        id={id}
        name={name}
        required={required}
        value={value}
        onChange={onChange}
      />
    </FormGroupWrapper>
  );
};

export default Input;
